<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="22000048" />
    <!-- <ImportDialog ref="importDialog"
      title="客户导入"
      fileUrl="/file/客户档案导入模板.xlsx"
      @sub="handleImport"
    /> -->
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl="vehicleFeePaymentParBO.ajax?cmd=doQuery"
          :params="fullSearchData"
          bizName="车辆费用数据导出"
          bizCode="CL00000924"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'busiCode'"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'busiCode'"
                @click="toDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-if="scope.column.property !== 'busiCode'">
                {{ scope.row[scope.column.property] }}
              </section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition:
                      (scope.row.state === 0 || scope.row.state === 4) &&
                      scope.row.isJurisdiction == true,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    showCondition:
                      (scope.row.state === 0 || scope.row.state === 1) &&
                      scope.row.sourceType !== 2,
                    name: '修改',
                    event: () => toEdit(scope.row.payId),
                  },
                  {
                    showCondition:
                      (scope.row.state === 0 || scope.row.state === 1) &&
                      scope.row.sourceType != 2,
                    name: '取消',
                    event: () => cancel(scope.row.payId),
                  },
                  {
                    name: '日志',
                    event: () => showLog(scope.row.payId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  carCostList,
  carCostCancelApply,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'busiCode',
            label: '申请单号',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
          {
            prop: 'applyUserName',
            label: '申请人',
          },
          {
            prop: 'applyTime',
            label: '申请时间',
          },
          {
            prop: 'feeAscriptionDate',
            label: '费用归属日期',
          },
          {
            prop: 'payAmt',
            label: '申请金额',
          },
          {
            prop: 'deductAmount',
            label: '抵扣借支',
          },
          {
            prop: 'shouldPayAmount',
            label: '应付金额',
          },
          {
            prop: 'costTypeName',
            label: '费用类型',
          },
          {
            prop: 'feeRemark',
            label: '费用说明',
          },
          {
            prop: 'receUserName',
            label: '收款方',
          },
          {
            prop: 'receBankName',
            label: '收款银行',
          },
          {
            prop: 'receBankNo',
            label: '收款账号',
          },
          {
            prop: 'payNo',
            label: '支付流水号',
          },
          {
            prop: 'orgName',
            label: '费用归属',
          },
          {
            prop: 'serviceName',
            label: '服务商',
          },
          {
            prop: 'isNeedBillName',
            label: '是否开票',
          },
          {
            prop: 'count',
            label: '条数',
          },
          {
            prop: 'auditTime',
            label: '修改时间',
          },
          {
            prop: 'sourceTypeName',
            label: '数据来源',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: carCostList,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核车辆费用' : '车辆费用详情',
        url: `/manage/cost/car/car/detail?id=${item.payId}&type=${type}`,
        full: true,
      });
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '车辆费用',
        url: `/manage/cost/car/car/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    async cancel (payId) {
      const confirmRes = await this.$confirm('是否确定取消申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const delRes = await carCostCancelApply({
          payId,
        });
        if (!delRes.failed) {
          this.$message({
            type: 'success',
            message: '已成功取消',
          });
          this.getData();
        }
      }
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
